var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.$vuetify.breakpoint.smAndDown ? 'margin-top: 80px;' : 'margin-top: 100px;')},[_c('v-container',{attrs:{"fluid":""}},[_c('PropertiesView',{attrs:{"display":_vm.display}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }